import React from 'react'
import css from './Skills.module.css'
import { motion } from "framer-motion";


import html from '../assets/icons/html.png'
import cssicon from '../assets/icons/css.png'
import js from '../assets/icons/js.png'
import react from '../assets/icons/react.png'
import tailwind from '../assets/icons/tailwind.png'
import sass from '../assets/icons/sass.png'
import bootstrap from '../assets/icons/bootstrap.png'
import nodejs from '../assets/icons/nodejs-.png'
import express from '../assets/icons/express.png'
import mongodb from '../assets/icons/mongodb-.png'
import postman from '../assets/icons/postman.png'
import git from '../assets/icons/git.png'
import angular from '../assets/icons/angular.png'
import netlify from '../assets/icons/netlify.png'

import ps from '../assets/icons/ps.png'
import pr from '../assets/icons/pr.png'
import ai from '../assets/icons/ai.png'





const Skills = () => {
  const transition = {
    duration: 1,
    type: "spring",
  };
  return (
<>
<a className="position_atag" id='skills'></a>

<div className={css.skillsbg} >
  <p>My Skills</p>
  <div className={css.list}>
{/* <div className={css.top}> */}
<motion.div
className={css.top}
          initial={{ left: "25vw" }}
          whileInView={{ left: "0vw" }}
          transition={transition}
        >
<div >
  <img src={html}/>
  <p>Html</p>
</div>
<div >
  <img src={cssicon}/>
  <p>Css</p>
</div>
<div >
  <img src={js}/>
  <p>Javascript</p>
</div>
<div >
  <img src={react}/>
  <p>React</p>
</div>
<div >
  <img src={tailwind}/>
  <p>Tailwind css</p>
</div>

<div >
  <img src={sass}/>
  <p>Sass</p>
</div>

<div >
  <img src={angular}/>
  <p>Angular</p>
</div>
{/* </div> */}
</motion.div>


{/* <div className={css.bottom}> */}

<motion.div
className={css.bottom}
          initial={{ right: "25vw" }}
          whileInView={{ right: "0vw" }}
          transition={transition}
        >
<div >
  <img src={bootstrap}/>
  <p>Bootstrap</p>
</div>
<div >
  <img src={nodejs}/>
  <p>Node js</p>
</div>
<div >
  <img src={express}/>
  <p>Express</p>
</div>
<div >
  <img src={mongodb}/>
  <p>Mongo db</p>
</div>
<div >
  <img src={postman}/>
  <p>Postman</p>
</div>
<div >
  <img src={git}/>
  <p>Git</p>
</div>
<div >
  <img src={netlify}/>
  <p>Netlify</p>
</div>
{/* </div> */}
</motion.div>
  </div>



  <hr></hr>
  {/* <div className={css.listtwo}> */}
  <motion.div
className={css.listtwo}
          // initial={{ bottom: "15vw" }}
          // whileInView={{ bottom: "0vw" }}
          // transition={transition}
        >
  <div >
  <img src={ps}/>
  <p>Photoshop</p>
</div>
<div >
  <img src={pr}/>
  <p>Premiere pro</p>
</div>
<div >
  <img src={ai}/>
  <p>Illustrator</p>
</div>
</motion.div>
  {/* </div> */}
</div>
</>
  )
}

export default Skills